import styled from 'styled-components';

const TeamCardContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 115px;
  padding: 10px 15px 15px 15px;
`;

const TeamCardHeader = styled.div`
  display: flex;
  margin-bottom: 10px;
  font-size: 20px;
  line-height: 34px;
  color: ${(props) => props.theme['color.text.title']};
`;

const TeamCardTitle = styled.div`
  width: calc(100% - 50px);
  padding-left: 5px;
  overflow: hidden;
  white-space:nowrap;
  text-overflow: ellipsis;
`;

const TeamCardContent = styled.div`
  display: flex;
`;

export {
  TeamCardContainer,
  TeamCardHeader,
  TeamCardTitle,
  TeamCardContent,
};
